import { type IPageOverviewBanner, Widget } from '@/interfaces';
import DefaultBanner from './DefaultBanner';
import BannerWithInfoBoard from './Widget/BannerWithInfoBoard';
import BannerWithTrackingWidget from './Widget/BannerWithTrackingWidget';
import BannerWithTradeRouteWidget from './Widget/BannerWithTradeRouteWidget';

const PageOverviewBanner: React.FC<IPageOverviewBanner> = ({ widget, ...props }) => {
  switch (widget) {
    case Widget.Tracking:
      return <BannerWithTrackingWidget {...props} />;
    case Widget.TradeRoute:
      return <BannerWithTradeRouteWidget {...props} />;
    case Widget.InfoBoard:
      return <BannerWithInfoBoard {...props} />;
    default:
      return <DefaultBanner {...props} />;
  }
};

export default PageOverviewBanner;
